/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../index.js";
export function IconPlaybackSpeed0Point5x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m13.338 12.5 1.97-1.97-1.06-1.06-1.97 1.97-1.97-1.97-1.06 1.06 1.97 1.97-1.97 1.97 1.06 1.06 1.97-1.97 1.97 1.97 1.06-1.06-1.97-1.97zm-.865-5.783v-.003a1.256 1.256 0 0 1-1.254-1.073l-1.485.2a2.761 2.761 0 1 0 2.091-3.017l.19-.821h2.553v-1.5H10.82l-.888 3.87 1.314.639.2-.248a1.277 1.277 0 0 1 1.027-.516 1.235 1.235 0 1 1 0 2.469zM6.78 4.33C6.778 1.858 5.617.385 3.67.385h.002C1.727.384.567 1.862.567 4.374c0 2.478 1.16 3.957 3.105 3.957s3.108-1.478 3.108-4zm-1.5.048C5.278 6.83 4.069 6.83 3.67 6.83h.002c-.4 0-1.605 0-1.605-2.494 0-2.453 1.208-2.453 1.605-2.453s1.608 0 1.608 2.494zM8.075 8.45a.975.975 0 1 0 0-1.95.975.975 0 0 0 0 1.95z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m20.627 15.177-2.543 2.543-2.543-2.543-1.415 1.414 2.543 2.543-2.543 2.543 1.415 1.414 2.543-2.543 2.543 2.543 1.414-1.414-2.544-2.543 2.544-2.543-1.415-1.414zM5.886.604c-3.031 0-4.772 2.232-4.772 6.185 0 3.9 1.74 6.13 4.772 6.13 3.03 0 4.769-2.231 4.769-6.2.002-3.885-1.738-6.115-4.77-6.115zm0 10.316c-1.838 0-2.772-1.39-2.772-4.19 0-2.74.934-4.126 2.772-4.126 1.838 0 2.769 1.385 2.769 4.19.002 2.738-.931 4.126-2.77 4.126zm6.112-.172a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm5.94.172a2.21 2.21 0 0 1-2.2-1.892l-1.984.264a4.213 4.213 0 1 0 2.882-4.517l.412-1.8h4.245v-2h-5.84L14.072 7.01l1.752.852.313-.388a2.246 2.246 0 0 1 1.806-.91 2.176 2.176 0 1 1 0 4.352l-.003.004z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
/**
 * @deprecated The name IconPlaybackSpeed0point5x is deprecated and will be archived soon. Use IconPlaybackSpeed0Point5x (with 'Point' capitalized) instead.
 */
export function IconPlaybackSpeed0point5x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed0Point5x, props);
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed0Point5x is deprecated and will be archived soon. Use IconPlaybackSpeed0Point5x instead.
 */
export function Experimental__IconPlaybackSpeed0Point5x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed0Point5x, props);
}